import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["isMobile"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import ChevronDown from '@carfax-stencils/icon/lib/src/chevronDown';
import ChevronRight from '@carfax-stencils/icon/lib/src/chevronRight';
import { getOpenNewTabProps } from '../utils';
import './LinkList.scss';
import useToggle from '../hooks/useToggle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Chevron = function Chevron(_ref) {
  var isOpen = _ref.isOpen,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size;
  return isOpen ? /*#__PURE__*/_jsx(ChevronDown, {
    size: size,
    "aria-hidden": true
  }) : /*#__PURE__*/_jsx(ChevronRight, {
    size: size,
    "aria-hidden": true
  });
};
var Links = function Links(_ref2) {
  var links = _ref2.links,
    _ref2$listClassName = _ref2.listClassName,
    listClassName = _ref2$listClassName === void 0 ? '' : _ref2$listClassName,
    _ref2$listItemClassNa = _ref2.listItemClassName,
    listItemClassName = _ref2$listItemClassNa === void 0 ? '' : _ref2$listItemClassNa,
    _ref2$anchorClassName = _ref2.anchorClassName,
    anchorClassName = _ref2$anchorClassName === void 0 ? '' : _ref2$anchorClassName;
  return /*#__PURE__*/_jsx("ul", {
    className: listClassName,
    children: links.map(function (_ref3, i) {
      var text = _ref3.text,
        url = _ref3.url,
        openInNewTab = _ref3.openInNewTab;
      var anchorProps = getOpenNewTabProps(!!openInNewTab);
      return /*#__PURE__*/_jsx("li", {
        className: listItemClassName,
        children: /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({
          href: url,
          className: anchorClassName,
          "aria-label": text,
          "aria-describedby": text
        }, anchorProps), {}, {
          children: text
        }))
      }, i);
    })
  });
};
var LinkListDesktop = function LinkListDesktop(_ref4) {
  var title = _ref4.title,
    links = _ref4.links;
  return /*#__PURE__*/_jsxs("div", {
    className: "cgf-linkList",
    children: [/*#__PURE__*/_jsx("p", {
      className: "cgf-linkList__heading",
      "aria-label": title,
      children: title
    }), /*#__PURE__*/_jsx(Links, {
      links: links,
      listItemClassName: "cgf-linkList__listitem",
      anchorClassName: "cgf-linkList__anchor"
    })]
  });
};
var LinkListMobile = function LinkListMobile(_ref5) {
  var title = _ref5.title,
    links = _ref5.links;
  var _useToggle = useToggle(),
    isOpen = _useToggle.value,
    toggleOpen = _useToggle.toggle;
  return /*#__PURE__*/_jsxs("div", {
    className: "cgf-linkList-mobile",
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsxs("button", {
        className: "cgf-linkList-mobile__button",
        onClick: toggleOpen,
        children: [title, /*#__PURE__*/_jsx(Chevron, {
          isOpen: isOpen
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      hidden: !isOpen,
      children: /*#__PURE__*/_jsx(Links, {
        links: links,
        listClassName: "cgf-linkList-mobile__list",
        listItemClassName: "cgf-linkList-mobile__listitem",
        anchorClassName: "cgf-linkList-mobile__anchor"
      })
    })]
  });
};
var LinkList = function LinkList(_ref6) {
  var isMobile = _ref6.isMobile,
    rest = _objectWithoutProperties(_ref6, _excluded);
  return isMobile ? /*#__PURE__*/_jsx(LinkListMobile, _objectSpread({}, rest)) : /*#__PURE__*/_jsx(LinkListDesktop, _objectSpread({}, rest));
};
export default LinkList;